var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { CampaignService } from './campaign.service';
var CampaignSegmentComponent = /** @class */ (function (_super) {
    __extends(CampaignSegmentComponent, _super);
    function CampaignSegmentComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.defMode = '';
        _this.readonly = false;
        _this.users = 0;
        _this.scope = false;
        _this.segmentSet = new SegmentSet();
        _this.segments = [];
        _this.segmentSetList = [];
        _this.segmentSetListId = 0;
        _this.fragmentList = [];
        _this.fragmentListId = [];
        return _this;
    }
    CampaignSegmentComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.subsc = this.service.observable.subscribe(function (data) {
            if (data && data['segment']) {
                _this.checkSegment();
                var segmentsErr = data['segment']['segmentsErr'] || [];
                for (var i = 0; i < _this.segments.length; i++) {
                    _this.checkFragment(i);
                    for (var j = 0; j < _this.segments[i].fragments.length; j++) {
                        _this.segments[i].fragments[j].error = segmentsErr[i][j];
                    }
                }
            }
        });
    };
    CampaignSegmentComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        if (this.component.params && this.component.params.mode) {
            this.defMode = this.component.params.mode;
        }
        if (this.component.params && this.component.params.readonly === true) {
            this.readonly = true;
        }
    };
    CampaignSegmentComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    CampaignSegmentComponent.prototype.onSubscribe = function (data) {
        this.scope = false;
        if (typeof data.unit_m !== 'undefined' && data.unit_m instanceof Array && data.unit_m.length > 1) {
            this.scope = true;
        }
        if (typeof data !== 'undefined' && typeof data.current !== 'undefined' && typeof data.includeLower !== 'undefined') {
            this.service.setUsersCount(data);
        }
        this.users = this.service.getUsersCount(this.scope);
        this.segmentSet = new SegmentSet();
        this.segments = [];
        if (data.campaign_id) {
            this.segmentSet.campaign_id = data.campaign_id;
            // edit
            if (data.segment_set_m && data.segment_set_m instanceof Array && data.segment_set_m[0]) {
                var segmentSet = data.segment_set_m[0];
                this.segmentSet.segment_set_id = segmentSet.segment_set_id;
                this.segmentSet.segment_set_title = segmentSet.segment_set_title;
                this.getList(segmentSet.segmentM);
                // entry
            }
            else {
                if (data.title) {
                    this.segmentSet.segment_set_title = data.title;
                }
                this.getList();
            }
        }
    };
    CampaignSegmentComponent.prototype.onModeSubscribe = function (mode) {
        if (this.defMode !== mode) {
            this.segmentSet = new SegmentSet();
            this.segments = [];
            this.service.setSegments(this.segments);
            this.action.deleteCompRec(this.componentName);
        }
    };
    CampaignSegmentComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    CampaignSegmentComponent.prototype.trackBySegment = function (index, segment) {
        return segment.segment_id;
    };
    CampaignSegmentComponent.prototype.trackByFragment = function (index, fragment) {
        return fragment.form_id;
    };
    CampaignSegmentComponent.prototype.getList = function (segments) {
        var _this = this;
        this.segmentSetList = [];
        this.segmentSetListId = 0;
        if (!this.readonly) {
            this.service.getSegmentSetList().subscribe(function (rec) {
                if (rec instanceof Array) {
                    _this.segmentSetList = rec;
                }
            });
        }
        this.fragmentList = [];
        this.fragmentListId = [];
        this.service.getFragmentList(this.segmentSet.campaign_id).subscribe(function (rec) {
            if (rec instanceof Array) {
                for (var _i = 0, rec_1 = rec; _i < rec_1.length; _i++) {
                    var item = rec_1[_i];
                    var segment = [];
                    for (var _a = 0, _b = item.segment; _a < _b.length; _a++) {
                        var seg = _b[_a];
                        segment.push({ code: seg.code_key, display: seg.code_label, num: seg.num });
                    }
                    _this.fragmentList.push(Object.assign({}, item, { segment: segment }));
                }
                if (segments) {
                    _this.setSegmentSet(segments);
                }
                else {
                    _this.setSegmentSetData();
                }
            }
        });
    };
    CampaignSegmentComponent.prototype.setSegmentSet = function (segments, mode) {
        this.service.sortPriority(segments);
        this.segments = [];
        this.fragmentListId = [];
        for (var i = 0; i < segments.length; i++) {
            var fragments = [];
            var segment = Object.assign(new Segment(), {
                segment_id: mode === 'copy' ? null : segments[i].segment_id,
                segment_title: segments[i].segment_title,
                condition: segments[i].condition,
                priority: segments[i].priority,
                is_editable: segments[i].is_editable
            });
            if (segment.is_editable) {
                var condition = JSON.parse(segment.condition);
                for (var _i = 0, _a = condition.searchConditionList; _i < _a.length; _i++) {
                    var cond = _a[_i];
                    var frag = new Fragment();
                    for (var _b = 0, _c = cond.predicateList; _b < _c.length; _b++) {
                        var predicate = _c[_b];
                        if (predicate.name === 'member_attribute.form_id') {
                            frag.form_id = predicate.value;
                            var f = jsonpath.value(this.fragmentList, '$..[?(@.form_id==' + predicate.value + ')]');
                            if (f) {
                                frag.name = f.name;
                                frag.segment_disp_type = f.segment_disp_type;
                                frag.attribute_type = f.attribute_type;
                                frag.segment = f.segment;
                            }
                        }
                        else if (predicate.name === 'member_attribute.value') {
                            if (predicate.operator === 'eq') {
                                frag.value = predicate.value;
                            }
                            else if (predicate.operator === 'in') {
                                frag.values = predicate.value.split(',');
                            }
                        }
                        else if (predicate.name === 'member_attribute.value1') {
                            frag.value1 = predicate.value;
                        }
                        else if (predicate.name === 'member_attribute.value2') {
                            frag.value2 = predicate.value;
                        }
                    }
                    fragments.push(frag);
                }
            }
            this.segments.push(Object.assign(new Segment(), segment, { fragments: fragments }));
            this.fragmentListId.push(0);
            this.getSegmentTarget(i);
        }
    };
    // 過去のセグメントセットをコピー
    CampaignSegmentComponent.prototype.copySegmentSet = function (id) {
        var _this = this;
        if (id === 0) {
            return;
        }
        this.service.getSegmentSet(id).subscribe(function (rec) {
            if (typeof rec !== 'undefined') {
                for (var _i = 0, _a = _this.segments; _i < _a.length; _i++) {
                    var segment = _a[_i];
                    if (segment.segment_id) {
                        _this.segmentSet.delete_segment_list.push(segment.segment_id);
                    }
                }
                _this.setSegmentSet(rec.segment_m, 'copy');
            }
        });
    };
    // セグメント並び替え
    CampaignSegmentComponent.prototype.sortSegment = function (e1, e2, index) {
        if (e2 === 'up') {
            this.segments.splice(index - 1, 2, this.segments[index], this.segments[index - 1]);
            this.fragmentListId.splice(index - 1, 2, this.fragmentListId[index], this.fragmentListId[index - 1]);
        }
        else if (e2 === 'down') {
            this.segments.splice(index, 2, this.segments[index + 1], this.segments[index]);
            this.fragmentListId.splice(index, 2, this.fragmentListId[index + 1], this.fragmentListId[index]);
        }
        this.setSegmentSetData();
    };
    // セグメント追加
    CampaignSegmentComponent.prototype.addSegment = function () {
        this.segments.push(new Segment());
        this.fragmentListId.push(0);
        this.getSegmentSetTarget();
        this.checkSegment();
    };
    // セグメント削除
    CampaignSegmentComponent.prototype.deleteSegment = function (index) {
        if (this.segments[index].segment_id) {
            this.segmentSet.delete_segment_list.push(this.segments[index].segment_id);
        }
        this.segments.splice(index, 1);
        this.fragmentListId.splice(index, 1);
        this.getSegmentSetTarget();
        this.checkSegment();
    };
    // セグメントチェック
    CampaignSegmentComponent.prototype.checkSegment = function () {
        this.segmentSet.error = (this.segments.length === 0 ? true : false);
    };
    // セグメント素片追加
    CampaignSegmentComponent.prototype.addFragment = function (index, id) {
        if (id === 0) {
            return;
        }
        this.segments[index].fragments.push(Object.assign(new Fragment(), jsonpath.value(this.fragmentList, '$..[?(@.form_id==' + id + ')]')));
        this.getSegmentTarget(index);
        this.checkFragment(index);
    };
    // セグメント素片削除
    CampaignSegmentComponent.prototype.deleteFragment = function (index, index2) {
        this.segments[index].fragments.splice(index2, 1);
        this.getSegmentTarget(index);
        this.checkFragment(index);
    };
    // セグメント要素チェック
    CampaignSegmentComponent.prototype.checkFragment = function (index) {
        this.segments[index].error = (this.segments[index].fragments.length === 0 ? true : false);
    };
    // checkbox
    CampaignSegmentComponent.prototype.onChange = function (e, index, index2) {
        var vals = this.segments[index].fragments[index2].values;
        if (vals.length > 0) {
            if (vals.indexOf(e.target.value) >= 0) {
                vals.splice(vals.indexOf(e.target.value), 1);
            }
        }
        if (e.target.checked) {
            vals.push(e.target.value);
        }
        this.segments[index].fragments[index2].values = vals.sort();
        this.getSegmentTarget(index);
    };
    CampaignSegmentComponent.prototype.getSegmentTarget = function (index) {
        var target = new Target();
        for (var _i = 0, _a = this.segments[index].fragments; _i < _a.length; _i++) {
            var fragment = _a[_i];
            if (fragment.segment_disp_type === 'unique' && fragment.value) {
                var num = jsonpath.value(fragment.segment, '$[?(@.code=="' + fragment.value + '")].num');
                if (num) {
                    target.value += num;
                }
            }
            else if (fragment.segment_disp_type === 'multiple') {
                for (var _b = 0, _c = fragment.values; _b < _c.length; _b++) {
                    var value = _c[_b];
                    var num = jsonpath.value(fragment.segment, '$[?(@.code=="' + value + '")].num');
                    if (num) {
                        target.value += num;
                    }
                }
            }
            else if (fragment.segment_disp_type === 'range' && (fragment.value1 || fragment.value2)) {
                // 0〜10の乱数を発生
                target.value += Math.floor(Math.random() * 11);
            }
        }
        if (this.users > 0) {
            target.percent = Math.floor(target.value / this.users * 100);
        }
        this.segments[index].target = target;
        this.getSegmentSetTarget();
    };
    CampaignSegmentComponent.prototype.getSegmentSetTarget = function () {
        var target = new Target();
        this.segmentSet.is_editable = true;
        for (var _i = 0, _a = this.segments; _i < _a.length; _i++) {
            var segment = _a[_i];
            target.value += segment.target.value;
            if (!segment.is_editable) {
                this.segmentSet.is_editable = false;
            }
        }
        if (this.users > 0) {
            target.percent = Math.floor(target.value / this.users * 100);
        }
        this.segmentSet.target = target;
        this.setSegmentSetData();
    };
    CampaignSegmentComponent.prototype.setSegmentSetData = function () {
        var segments = [];
        for (var i = 0; i < this.segments.length; i++) {
            var segment = this.segments[i];
            if (segment.is_editable) {
                var fragments = [];
                for (var j = 0; j < segment.fragments.length; j++) {
                    var fragment = segment.fragments[j];
                    var predicateList = [];
                    predicateList.push(Object.assign(new Predicate(), { name: 'member_attribute.form_type', value: 1 }));
                    predicateList.push(Object.assign(new Predicate(), {
                        name: 'member_attribute.attribute_type',
                        value: fragment.attribute_type
                    }));
                    predicateList.push(Object.assign(new Predicate(), {
                        name: 'member_attribute.form_id',
                        value: fragment.form_id
                    }));
                    if (fragment.segment_disp_type === 'unique' && fragment.value) {
                        fragment.error = false;
                        predicateList.push(Object.assign(new Predicate(), {
                            name: 'member_attribute.value',
                            value: fragment.value
                        }));
                    }
                    else if (fragment.segment_disp_type === 'multiple' && fragment.values.length > 0) {
                        fragment.error = false;
                        predicateList.push(Object.assign(new Predicate(), {
                            name: 'member_attribute.value',
                            value: fragment.values.join(','),
                            operator: 'in'
                        }));
                    }
                    else if (fragment.segment_disp_type === 'range' && (fragment.value1 || fragment.value2)) {
                        if (fragment.value1) {
                            fragment.error = false;
                            predicateList.push(Object.assign(new Predicate(), {
                                name: 'member_attribute.value1',
                                value: fragment.value1
                            }));
                        }
                        if (fragment.value2) {
                            fragment.error = false;
                            predicateList.push(Object.assign(new Predicate(), {
                                name: 'member_attribute.value2',
                                value: fragment.value2
                            }));
                        }
                    }
                    else {
                        continue;
                    }
                    var frag = { predicateList: predicateList, no: j + 1 };
                    if (j > 0) {
                        frag['operator'] = 'and';
                    }
                    fragments.push(frag);
                }
                if (fragments.length > 0) {
                    segment.condition = JSON.stringify({ searchConditionList: fragments });
                }
                else {
                    segment.condition = '';
                }
            }
            var seg = {
                segment_title: segment.segment_title,
                priority: i + 1,
                is_editable: segment.is_editable,
                condition: segment.condition
            };
            if (segment.segment_id) {
                seg['segment_id'] = segment.segment_id;
            }
            segments.push(seg);
        }
        var segSet = {
            campaign_id: this.segmentSet.campaign_id,
            segment_set_title: this.segmentSet.segment_set_title,
            segment_m: segments
        };
        if (this.segmentSet.segment_set_id) {
            segSet['segment_set_id'] = this.segmentSet.segment_set_id;
        }
        if (this.segmentSet.delete_segment_list.length > 0) {
            segSet['delete_segment_list'] = this.segmentSet.delete_segment_list.join(',');
        }
        this.service.setSegments(this.segments);
        this.action.setCompRec(this.componentName, segSet);
    };
    CampaignSegmentComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.subsc.unsubscribe();
    };
    CampaignSegmentComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'campaign-segment',
                    template: "<div *ngIf=\"defMode === mode\" id=\"{{ componentName }}\">\n  <div class=\"row -m-3\">\n    <div class=\"col-sm-12\">\n      <p *ngIf=\"segmentSet.is_editable\">\n        <span class=\"sectionHeading sectionHeading-gray\">{{ (msg | async)['CampaignSegmentComponent.label.total'] }}{{ segmentSet.target.value }}{{ (msg | async)['CampaignSegmentComponent.label.people'] }}</span><span class=\"-note -ml-05 -autoBreak\">{{ segmentSet.target.percent }}{{ (msg | async)['CampaignSegmentComponent.label.percent'] }}</span>\n      </p>\n      <p *ngIf=\"!segmentSet.is_editable\">\n        <span class=\"sectionHeading sectionHeading-gray\">{{ (msg | async)['CampaignSegmentComponent.label.total'] }}{{ (msg | async)['CampaignSegmentComponent.label.uncounted'] }}</span>\n      </p>\n    </div>\n  </div>\n  <div *ngIf=\"!readonly\" class=\"row -m-3\">\n    <div class=\"col-sm-12\">\n      <dl class=\"form\">\n        <dt class=\"form_dt\"></dt>\n        <dd class=\"form_dd\">\n          <ul>\n            <li class=\"form_li\">\n              <select [(ngModel)]=\"segmentSetListId\" name=\"segmentSetList\" class=\"formSelect\">\n                <option [ngValue]=\"0\" [selected]=\"segmentSetListId === 0\">{{ (msg | async)['CampaignSegmentComponent.label.selectSegmentset'] }}</option>\n                <option *ngFor=\"let option of segmentSetList; trackBy: trackByOption\" [ngValue]=\"option.code\">{{ option.display }}</option>\n              </select>\n            </li>\n            <li class=\"form_li\">\n              <a href=\"javascript:void(0);\" (click)=\"copySegmentSet(segmentSetListId)\">{{ (msg | async)['CampaignSegmentComponent.label.copy'] }}</a>\n            </li>\n          </ul>\n        </dd>\n      </dl>\n    </div>\n  </div>\n  <div class=\"row -m-3\">\n    <div class=\"col-sm-12\">\n      <dl class=\"form\">\n        <dt class=\"form_dt\"><label class=\"formLabelText\">{{ (msg | async)['CampaignSegmentComponent.label.segmentset'] }}</label></dt>\n        <dd class=\"form_dd\">\n          <ul *ngIf=\"!readonly\">\n            <li class=\"form_li form_li-w100per\">\n              <column-text [key]=\"'form'\"\n                           [col]=\"{key: 'segment_set_title', controlType: 'text', required: true}\"\n                           [val]=\"segmentSet.segment_set_title\"\n                           [msg]=\"(msg | async)\" (changeVal)=\"segmentSet.segment_set_title=$event.val;setSegmentSetData();\"></column-text>\n              <input type=\"hidden\" name=\"segment_set_id\" [(ngModel)]=\"segmentSet.segment_set_id\">\n            </li>\n          </ul>\n          <ul *ngIf=\"readonly\">\n            <li class=\"form_li form_li-w100per\">\n              <column-formreadonly [col]=\"{controlType: 'text'}\" [val]=\"segmentSet.segment_set_title\" [msg]=\"(msg | async)\"></column-formreadonly>\n            </li>\n          </ul>\n        </dd>\n      </dl>\n    </div>\n  </div>\n  <horizontal-rule></horizontal-rule>\n  <div class=\"row -mx-5 -my-3\">\n    <div class=\"col-sm-12\">\n      <p *ngIf=\"!readonly\" class=\"-note\">{{ (msg | async)['CampaignSegmentComponent.label.note'] }}</p>\n      <p *ngIf=\"readonly\" class=\"-note\">{{ (msg | async)['CampaignSegmentComponent.label.note.readonly'] }}</p>\n    </div>\n  </div>\n  <div *ngIf=\"segments.length > 0\" class=\"row -m-3\">\n    <div class=\"col-sm-12\">\n      <ul class=\"form form-campaign\">\n        <li *ngFor=\"let segment of segments; let index = index; trackBy: trackBySegment\" class=\"stageFlowPane\">\n          <div *ngIf=\"!readonly\" class=\"stageFlow_arrowsWrapper\">\n            <ul class=\"stageFlow_arrows\">\n              <li *ngIf=\"index > 0\"><a href=\"javascript:void(0);\" class=\"stageFlow_arrows_up\" (click)=\"sortSegment($event, 'up', index)\"></a></li>\n              <li *ngIf=\"index < segments.length - 1\"><a href=\"javascript:void(0);\" class=\"stageFlow_arrows_down\" (click)=\"sortSegment($event, 'down', index)\"></a></li>\n            </ul>\n          </div>\n          <div class=\"stageFlowPane_border\">\n            <p *ngIf=\"!readonly\"><a class=\"deleteBtn\" href=\"javascript:void(0);\" (click)=\"deleteSegment(index)\"></a></p>\n            <dl class=\"form\">\n              <dt class=\"form_dt\"><label class=\"formLabelText\">{{ (msg | async)['CampaignSegmentComponent.label.segment'] }}</label></dt>\n              <dd class=\"form_dd\">\n                <ul *ngIf=\"!readonly\">\n                  <li class=\"form_li form_li-w100per\">\n                    <column-text [key]=\"'form'\"\n                                 [col]=\"{key: 'segment_title-' + index, controlType: 'text', required: true}\"\n                                 [val]=\"segment.segment_title\"\n                                 [msg]=\"(msg | async)\" (changeVal)=\"segment.segment_title=$event.val;setSegmentSetData();\"></column-text>\n                    <input type=\"hidden\" name=\"segment_id-{{ index }}\" [(ngModel)]=\"segment.segment_id\">\n                  </li>\n                </ul>\n                <ul *ngIf=\"readonly\">\n                  <li class=\"form_li form_li-w100per\">\n                    <column-formreadonly [col]=\"{controlType: 'text'}\" [val]=\"segment.segment_title\" [msg]=\"(msg | async)\"></column-formreadonly>\n                  </li>\n                </ul>\n              </dd>\n            </dl>\n\n            <ng-template [ngIf]=\"segment.is_editable\">\n              <div *ngFor=\"let fragment of segment.fragments; let index2 = index; trackBy: trackByFragment\" class=\"stageFlowPane_border2\">\n                <p *ngIf=\"!readonly\"><a class=\"deleteBtn\" href=\"javascript:void(0);\" (click)=\"deleteFragment(index, index2)\"></a></p>\n                <dl class=\"form\">\n                  <dt class=\"form_dt\"><label class=\"formLabelText\">{{ (msg | async)['CampaignSegmentComponent.label.fragment'] }} {{ fragment.name }}</label></dt>\n                  <dd class=\"form_dd\">\n                    <ng-template [ngIf]=\"fragment.segment_disp_type === 'unique'\">\n                      <p *ngIf=\"fragment.error\" class=\"formError\">{{ (msg | async)['CampaignSegmentComponent.error.unique'] }}</p>\n                      <ul *ngIf=\"!readonly\">\n                        <li class=\"form_li\">\n                          <ng-template ngFor let-option [ngForOf]=\"fragment.segment\" [ngForTrackBy]=\"trackByOption\">\n                            <input class=\"formInputRadio\" type=\"radio\" id=\"fragment_unique-{{ index }}-{{ index2 }}-{{ option.code }}\" name=\"fragment_unique-{{ index }}-{{ index2 }}\" [value]=\"option.code\" [(ngModel)]=\"fragment.value\" (change)=\"getSegmentTarget(index)\">\n                            <label for=\"fragment_unique-{{ index }}-{{ index2 }}-{{ option.code }}\" class=\"formInputRadioLabel\">{{ option.display }}[{{ option.num }}]</label>\n                          </ng-template>\n                        </li>\n                      </ul>\n                      <ul *ngIf=\"readonly\">\n                        <li class=\"form_li\">\n                          <ng-template ngFor let-option [ngForOf]=\"fragment.segment\" [ngForTrackBy]=\"trackByOption\">\n                            <column-formreadonly *ngIf=\"fragment.value === option.code\" [col]=\"{controlType: 'text'}\" [val]=\"option.display+'['+option.num+']'\" [msg]=\"(msg | async)\"></column-formreadonly>\n                          </ng-template>\n                        </li>\n                      </ul>\n                    </ng-template>\n                    <ng-template [ngIf]=\"fragment.segment_disp_type === 'multiple'\">\n                      <p *ngIf=\"fragment.error\" class=\"formError\">{{ (msg | async)['CampaignSegmentComponent.error.multiple'] }}</p>\n                      <ul *ngIf=\"!readonly\">\n                        <li class=\"form_li\">\n                          <ng-template ngFor let-option [ngForOf]=\"fragment.segment\" [ngForTrackBy]=\"trackByOption\">\n                            <input class=\"formInputCheckbox\" type=\"checkbox\" id=\"fragment_multiple-{{ index }}-{{ index2 }}-{{ option.code }}\" name=\"fragment_multiple-{{ index }}-{{ index2 }}\" value=\"{{ option.code }}\" [checked]=\"fragment.values && fragment.values.indexOf(option.code) >= 0\" (change)=\"onChange($event, index, index2)\">\n                            <label for=\"fragment_multiple-{{ index }}-{{ index2 }}-{{ option.code }}\" class=\"formInputCheckboxLabel\">{{ option.display }}[{{ option.num }}]</label>\n                          </ng-template>\n                        </li>\n                      </ul>\n                      <ul *ngIf=\"readonly\">\n                        <li class=\"form_li form_li-inlineList\">\n                          <ng-template ngFor let-option [ngForOf]=\"fragment.segment\" [ngForTrackBy]=\"trackByOption\">\n                            <column-formreadonly *ngIf=\"fragment.values && fragment.values.indexOf(option.code) >= 0\" [col]=\"{controlType: 'text'}\" [val]=\"option.display+'['+option.num+']'\" [msg]=\"(msg | async)\"></column-formreadonly>\n                          </ng-template>\n                        </li>\n                      </ul>\n                    </ng-template>\n                    <ng-template [ngIf]=\"fragment.segment_disp_type === 'range'\">\n                      <p *ngIf=\"fragment.error\" class=\"formError\">{{ (msg | async)['CampaignSegmentComponent.error.range'] }}</p>\n                      <ul *ngIf=\"!readonly\">\n                        <li class=\"form_li form_li-w100\">\n                          <input type=\"number\" class=\"formInputText\" name=\"fragment_range-{{ index }}-{{ index2 }}-1\" [(ngModel)]=\"fragment.value1\" (change)=\"getSegmentTarget(index)\">\n                        </li>\n                        <li class=\"form_li\">~</li>\n                        <li class=\"form_li form_li-w100\">\n                          <input type=\"number\" class=\"formInputText\" name=\"fragment_range-{{ index }}-{{ index2 }}-2\" [(ngModel)]=\"fragment.value2\" (change)=\"getSegmentTarget(index)\">\n                        </li>\n                      </ul>\n                      <ul *ngIf=\"readonly\">\n                        <li class=\"form_li\">\n                          <column-formreadonly [col]=\"{controlType: 'number'}\" [val]=\"fragment.value1\" [msg]=\"(msg | async)\"></column-formreadonly>\n                        </li>\n                        <li class=\"form_li\">~</li>\n                        <li class=\"form_li\">\n                          <column-formreadonly [col]=\"{controlType: 'number'}\" [val]=\"fragment.value2\" [msg]=\"(msg | async)\"></column-formreadonly>\n                        </li>\n                      </ul>\n                    </ng-template>\n                  </dd>\n                </dl>\n              </div>\n\n              <div *ngIf=\"!readonly\" class=\"stageFlowPane_border2\">\n                <p *ngIf=\"segment.error\" class=\"formError -mb-1\">{{ (msg | async)['CampaignSegmentComponent.error.fragment'] }}</p>\n                <dl class=\"form\">\n                  <dt class=\"form_dt\"><label class=\"formLabelText\"></label></dt>\n                  <dd class=\"form_dd\">\n                    <ul>\n                      <li class=\"form_li\">\n                        <select [(ngModel)]=\"fragmentListId[index]\" name=\"fragmentList-{{ index }}\" class=\"formSelect\">\n                          <option [ngValue]=\"0\" [selected]=\"fragmentListId[index] === 0\">{{ (msg | async)['CampaignSegmentComponent.label.selectFragment'] }}</option>\n                          <option *ngFor=\"let option of fragmentList; trackBy: trackByFragment\" [ngValue]=\"option.form_id\">{{ option.name }}</option>\n                        </select>\n                      </li>\n                      <li class=\"form_li\">\n                        <a href=\"javascript:void(0);\" (click)=\"addFragment(index, fragmentListId[index])\">{{ (msg | async)['CampaignSegmentComponent.label.addFragment'] }}</a>\n                      </li>\n                    </ul>\n                  </dd>\n                </dl>\n              </div>\n              <p>{{ (msg | async)['CampaignSegmentComponent.label.total'] }} <span class=\"sectionHeading\">{{ segment.target.value }}{{ (msg | async)['CampaignSegmentComponent.label.people'] }}</span><span> {{ segment.target.percent }}{{ (msg | async)['CampaignSegmentComponent.label.percent'] }}</span></p>\n            </ng-template>\n            <ng-template [ngIf]=\"!segment.is_editable\">\n              <p class=\"-mt-1\">{{ (msg | async)['CampaignSegmentComponent.label.total'] }} <span class=\"sectionHeading\">{{ (msg | async)['CampaignSegmentComponent.label.uncounted'] }}</span></p>\n            </ng-template>\n          </div>\n        </li>\n      </ul>\n    </div>\n  </div>\n  <div *ngIf=\"!readonly\" class=\"row -mx-5 -my-3\">\n    <div class=\"col-sm-12\">\n      <p *ngIf=\"segmentSet.error\" class=\"formError -mb-3\">{{ (msg | async)['CampaignSegmentComponent.error.segment'] }}</p>\n      <p><a href=\"javascript:void(0);\" (click)=\"addSegment()\">{{ (msg | async)['CampaignSegmentComponent.label.addSegment'] }}</a></p>\n    </div>\n  </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    CampaignSegmentComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: CampaignService }
    ]; };
    return CampaignSegmentComponent;
}(ContentBaseComponent));
export { CampaignSegmentComponent };
var SegmentSet = /** @class */ (function () {
    function SegmentSet() {
        this.is_editable = true;
        this.target = new Target();
        this.delete_segment_list = [];
        this.error = false;
    }
    return SegmentSet;
}());
var Segment = /** @class */ (function () {
    function Segment() {
        this.condition = '';
        this.fragments = [];
        this.is_editable = true;
        this.target = new Target();
        this.error = false;
    }
    return Segment;
}());
var Predicate = /** @class */ (function () {
    function Predicate() {
        this.operator = 'eq';
    }
    return Predicate;
}());
export var DispType;
(function (DispType) {
    DispType.unique = 'unique';
    DispType.multiple = 'multiple';
    DispType.range = 'range';
})(DispType || (DispType = {}));
var Fragment = /** @class */ (function () {
    function Fragment() {
        this.segment = [];
        this.values = []; // multiple
        this.error = false;
    }
    return Fragment;
}());
var Target = /** @class */ (function () {
    function Target() {
        this.value = 0; // 人数
        this.percent = 0; // パーセント
    }
    return Target;
}());
//# sourceMappingURL=campaign-segment.component.js.map